import Typography from "@portal/components/atoms/v2/typography";
import { useState } from "react";
import { MainBox } from "../components/mainBox";
import { MapIndexToSavingPeriod, MapSavingPeriodToIndex } from "./helpers";
import { PlanningInfo, PlanningOptions } from "./components";
import { RadioGroup } from "@headlessui/react";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { useRobot } from "@portal/app/context/robotProvider";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";
import { ToggleButton } from "@portal/components/atoms/buttons/toggle/ToggleButton";
import { RobotFooterComponent } from "../components/footer";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import { UserMessageComponent } from "../components/message/UserMessageComponent";
import RadioComponent from "@portal/components/atoms/v2/radioComponent";
import Link from "next/link";

import { SavingOfTotalEconomy } from "@portal/types/robot/IRobotEnums";

export const PlanningPage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const { riskLevelRequest, setSavingPeriod, setSavingOfTotalEconomy } = useRobot();
  const [isToggleBoxOpen, setIsToggleBoxOpen] = useState(false);
  const [showUserMessage, setShowUserMessage] = useState(false);

  const isButtonDisabled = riskLevelRequest.savingPeriod === null || riskLevelRequest.savingOfTotalEconomy === null;

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const headers = [texts.PAGE_4_A_A, texts.PAGE_4_A, texts.PAGE_4_B, texts.PAGE_4_C, texts.PAGE_4_D];
  const options = [texts.PAGE_4_A_A_1, texts.PAGE_4_A_1, texts.PAGE_4_B_1, texts.PAGE_4_C_1, texts.PAGE_4_D_1];

  const OnRadioButtonClick = (index: number) => {
    const result = index === 0 ? SavingOfTotalEconomy.Smaller : SavingOfTotalEconomy.Larger;
    setSavingOfTotalEconomy(result);
  };

  const OnSelectionClick = (selectedOption: number) => {
    if (selectedOption === 0) {
      setShowUserMessage(true);
      return;
    }
    if (selectedOption !== null) {
      const result = MapIndexToSavingPeriod(selectedOption);
      setSavingPeriod(result);
    }
  };

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_4_SUBHEADER}</Typography>
        <TextLine />
        <InfoBoxComponent header={texts.TEXT_QUESTION} texts={[texts.PAGE_4_INFO_BOX]} marginTop={10} />
        <PlanningOptions
          headers={headers}
          options={options}
          selectedItem={MapSavingPeriodToIndex(riskLevelRequest.savingPeriod) ?? -1}
          onSelectionClick={OnSelectionClick}
        />
        <div className="flex mb-5 ml-2">
          <Link prefetch={false} href="/ips" target="_blank" className="flex underline items-start">
            <Typography variant="Body">{texts.PAGE_4_E}</Typography>
          </Link>
        </div>
        <RadioGroup value={riskLevelRequest.savingOfTotalEconomy ?? -1} onChange={OnRadioButtonClick} className="space-y-2">
          <RadioComponent
            id="SavingOfTotalEconomySmall"
            text={texts.PAGE_4_CHECKBOX_A}
            value={SavingOfTotalEconomy.Smaller}
            large
          />
          <RadioComponent
            id="SavingOfTotalEconomyLarge"
            text={texts.PAGE_4_CHECKBOX_B}
            value={SavingOfTotalEconomy.Larger}
            large
          />
        </RadioGroup>
        <ToggleButton
          activeText={texts.PAGE_4_BUTTON_TEXT_ACTIVE}
          inActiveText={texts.TEXT_CLOSE}
          expanded={isToggleBoxOpen}
          setExpanded={setIsToggleBoxOpen}
        />
        {isToggleBoxOpen && <PlanningInfo isDefaultLanguage={isDefaultLanguage} />}
      </MainBox>

      {showUserMessage && (
        <UserMessageComponent
          userMessage={texts.MESSAGE_NO_FUND_FOR_YOU}
          showDialog={showUserMessage}
          secondaryButtonText={texts.MESSAGE_CHANGE_REPLY}
          secondaryButtonClick={() => {
            setShowUserMessage(false);
          }}
        />
      )}
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};
